export default __webpack_public_path__ + "static/media/careers.c03fd93a.svg";